import { useEffect, useState } from 'react';
import { styled, useStyletron } from 'baseui'
import { Button, KIND, SHAPE, SIZE } from 'baseui/button';
import { TDailySchedule, TScheduler } from './types'
import { useIntl, FormattedMessage } from 'react-intl';
import { OperatorPanelWrapperFullSize } from '../../components/Layout';
import { StateText } from './components/StateText';
import { Banner, KIND as KINDBanner } from 'baseui/banner';
import { StyledLink } from 'baseui/link';
import { Link } from 'react-router-dom';
import { GetObjectUrl } from '../../../utils/navigationService';
import { NotificationCircle } from 'baseui/badge';
import WeeklySchedule from './WeeklySchedule/WeeklySchedule';
import ExceptionsDialog from './Exceptions/ExceptionsDialog';
import { getValueOptions } from './utils';
import { IAddEventState } from './AddEntryDialog';
import AddEntryButton from './AddEntryDialog/AddEntryButton';
import useWeeklySchedule from './hooks/useWeeklySchedule';
import useExceptionSchedule from './hooks/useExceptionSchedule';
import { TDailyScheduleExtensions } from './typeExtensions/TDailyScheduleExtensions';
import { LoadingView } from '../../../components';


const Scheduler = (props: TScheduler) => {
  const [css, theme] = useStyletron();
  const intl = useIntl();
  const [showExceptions, setShowExceptions] = useState(false);
  const { weeklySchedule,hasChanges, save, update, isSaving, updateAll, isLoading, isSuccess } = useWeeklySchedule(props.id,props.resourceGroupId);
  const { exceptionSchedule } = useExceptionSchedule(props.id, props.resourceGroupId);
  
  const handleChanged = (day: TDailySchedule) => update(day);
  const handleApplyChanges = () => save();
  const handleAddEvent = (args: IAddEventState) => {
    const updated = TDailyScheduleExtensions.addItems(weeklySchedule, args.timeFrom,args.timeTo,args.value,args.days);
    updateAll(updated);
  }

  const exceptionsSchedCount = exceptionSchedule?.length ?? 0;
  const valueOptions = getValueOptions(props);

  return (
    <OperatorPanelWrapperFullSize
      objectId={props.id}
      resourceGroupId={props.resourceGroupId}
      statusContent={
        <StateContainer>
          <div> </div>
          <StateText  {...props}></StateText>
          <NotificationCircle
            content={exceptionsSchedCount}
            hidden={false}
            color={exceptionsSchedCount ? 'accent' : 'primary'}
            placement={'topRight'}
            horizontalOffset="-5px"
            verticalOffset="0px"
          >
            <Button size='compact' shape='pill' kind='tertiary' onClick={() => setShowExceptions(true)} ><u>{intl.formatMessage({ id: "Scheduler.ExceptioSchedules", defaultMessage: "show Exceptions" })}</u></Button>
          </NotificationCircle>
        </StateContainer>
      }
      operationModeContent={
        <>
          {(!props.timeZone || props.timeZone === 'UTC') && props.schema === 'AutomationApps.Functions.Schedules.ControlledScheduler' &&
            <Banner kind={KINDBanner.warning}>
              <FormattedMessage id="Scheduler.NotInitializedTimezone" defaultMessage="Timezone configuration is missing." />
              <span> </span>
              <Link to={`${GetObjectUrl(props.resourceGroupId, props.id)}?defaultView=configuration`} className={css({ textDecoration: 'none' })}>
                <StyledLink animateUnderline ><FormattedMessage id="configuration" defaultMessage="Configuration" /></StyledLink>
              </Link>
            </Banner>}</>
      }
      additionalContent={
        <ContentContainer>
          <LoadingView isLoading={isLoading} isSucess={isSuccess}>
          <div className={css({
            position: 'relative',
            width: '100%'
          })}>

            <WeeklySchedule onDayChanged={handleChanged} app={props} days={weeklySchedule}></WeeklySchedule>
            {hasChanges &&
              <div className={css({
                position: 'absolute',
                bottom: '-20px',
                left: '50%',
                zIndex: 9999,
              })}>
                <Button shape='pill' overrides={{
                  BaseButton: {
                    style: ({ $theme }) => ({
                      boxShadow: $theme.lighting.shadow400,
                    })
                  }
                }} size='compact' isLoading={isSaving} onClick={handleApplyChanges}><FormattedMessage id="applyChanges" defaultMessage="Apply changes" /></Button>
              </div>}


            <div className={css({
              position: 'absolute',
              bottom: '-20px',
              right: '-20px',
              zIndex: 9999,
            })}>

              <AddEntryButton {...props} onAdd={handleAddEvent} showDays={true} valueOptions={valueOptions}></AddEntryButton>
            </div>
          </div>

          {showExceptions && <ExceptionsDialog isOpen={showExceptions} setIsOpen={setShowExceptions} app={props} ></ExceptionsDialog>}
          </LoadingView>
        </ContentContainer>
      }>
    </OperatorPanelWrapperFullSize>
  );
}

export default Scheduler;


const ContentContainer = styled<'div', {}>("div", ({ $theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  rowGap: $theme.sizing.scale200,
  columnGap: $theme.sizing.scale200,
  alignItems: 'flex-start',
  height: '100%'
}));




const StateContainer = styled<'div', {}>("div", ({ $theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
  gridGap: $theme.sizing.scale300
}));